import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import { InitiatePasswordChange } from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class InitiatePasswordChangeService {
  initiatePasswordChangeHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.initiatePasswordChange+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  initiatePasswordChange = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<InitiatePasswordChange> => {
    const getInitiatePasswordChangeUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const initiatePasswordChangeUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getInitiatePasswordChangeUrl
      }
    ];

    return new ApiBuilder<undefined, InitiatePasswordChange>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(initiatePasswordChangeUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.initiatePasswordChangeHeader)
      .errorHandler(this._errorHandler)
      .library('INITIATE_PASSWORD_CHANGE_SERVICE')
      .withCredentials(true)
      .create();
  };
}
